import React from 'react'
import Footer from '../components/footer/Footer'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import SecondFaq from '../components/secondFaq/SecondFaq'
import TrendsInsights from '../components/trends-n-insights/TrendsInsights'
import HirePageSteps from '../components/hire-page-steps/HirePageSteps'
import HireCombinationSection from '../components/hire-combination-sectiono/HireCombinationSection'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs'
import NewTestimonials from '../components/new-testimonials/NewTestimonials'
import OurServices from '../components/our-services/OurServices'
import TrustedPartner from '../components/trustedPartners/TrustedPartner'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import MegaMenu from '../components/MegaMenu/MegaMenu'
import { Helmet } from 'react-helmet'
import { hireMobileAIMLEngeniersContent } from '../data/hire-mobile-ai-ml-engineers'
import CoverTheStack from '../components/coverthestack/CoverTheStack'

const HireMobileAIMLEngeniers = () => {
    return (
        <>
            <Helmet>
                <title>Hire Mobile AI & ML Engineers | AI-Driven App Experts for iOS & Android - Bitsclan</title>
                <meta name="description" content="Hire top mobile AI & ML engineers to build intelligent iOS and Android apps. Our expert mobile app developers deliver AI-driven mobile solutions that boost performance, engagement, and innovation." />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={hireMobileAIMLEngeniersContent?.mainBanner?.shortHeading}
                mainHeading={hireMobileAIMLEngeniersContent?.mainBanner?.mainHeading}
                description={hireMobileAIMLEngeniersContent?.mainBanner?.content}
            />

            <TrustedPartner />

            <OurServices
                shortHeading={hireMobileAIMLEngeniersContent?.mobileAIMLExpertise?.shortHeading}
                mainHeading={hireMobileAIMLEngeniersContent?.mobileAIMLExpertise?.heading}
                description={hireMobileAIMLEngeniersContent?.mobileAIMLExpertise?.description}
                servicesCardsData={hireMobileAIMLEngeniersContent?.mobileAIMLExpertise?.servicesData}
                buttonText="Start Your Mobile AI & ML Project"
            />

            <NewTestimonials
                shortHeading=" Some of Our Happy Clients"
                mainHeading="What Our Clients Say About Bitsclan's <span>Mobile AI & ML Expertise</span>"
                description="We take pride in our Mobile AI & ML app development services, earning positive feedback from clients who value our dedication, quality, & reliable results. Their satisfaction inspires us to deliver exceptional mobile solutions every time."
            />

            <WhyChooseUs
                shortHeading={hireMobileAIMLEngeniersContent?.whyChooseUs?.shortHeading}
                greenHeading={hireMobileAIMLEngeniersContent?.whyChooseUs?.greenHeading}
                heading={hireMobileAIMLEngeniersContent?.whyChooseUs?.mainHeading}
                content={hireMobileAIMLEngeniersContent?.whyChooseUs?.description}
                stats={hireMobileAIMLEngeniersContent?.whyChooseUs?.statsData}
            />

            <NewCaseStudySection
                shortHeading="Our Mobile AI & ML Development Success Stories"
                heading="Proven Mobile AI & ML Solutions Driving Real-World Results"
                description="Through our Mobile AI & ML development services, we’ve created dynamic, high-performing applications that align with client goals. We deliver innovative Mobile AI & ML solutions, blending speed, design, & functionality to surpass client's expectations & ensure measurable business growth."
            />

            <HireCombinationSection
                shortHeading={hireMobileAIMLEngeniersContent?.techCombinations?.shortHeading}
                combinations={hireMobileAIMLEngeniersContent?.techCombinations.combinations}
                heading={hireMobileAIMLEngeniersContent?.techCombinations.heading}
                description={hireMobileAIMLEngeniersContent?.techCombinations.description}
            />

            <HirePageSteps
                buttonText={hireMobileAIMLEngeniersContent?.hireSteps.btnText}
                heading={hireMobileAIMLEngeniersContent?.hireSteps.heading}
                subHeading={hireMobileAIMLEngeniersContent?.hireSteps.subHeading}
                steps={hireMobileAIMLEngeniersContent?.hireSteps.steps}
            />

            <CoverTheStack
                shortHeading={hireMobileAIMLEngeniersContent?.coverTheStack?.shortHeading}
                whereStart={hireMobileAIMLEngeniersContent?.coverTheStack?.whereStart}
                mainHeading={hireMobileAIMLEngeniersContent?.coverTheStack?.mainHeading}
                subHeading={hireMobileAIMLEngeniersContent?.coverTheStack?.subHeading}
                tabs={hireMobileAIMLEngeniersContent?.coverTheStack?.tabs}
                tabItems={hireMobileAIMLEngeniersContent?.coverTheStack?.tabItems}
            />

            <TrendsInsights heading="Expert Insights to Accelerate Your Mobile AI & ML App Success" description="Our Mobile AI & ML specialists reveal practical techniques, frameworks, & trending solutions for mobile app development. We guide businesses & teams to streamline processes, enhance app performance, & deliver outstanding user experiences across iOS & android platforms with Mobile AI & ML versatile capabilities." specificClass="mobile-dev-page" category="all" />

            <SecondFaq
                specificClass="mobile-dev-page"
                faqs={hireMobileAIMLEngeniersContent?.faqSection.faqData}
                mainHeading={hireMobileAIMLEngeniersContent?.faqSection.mainHeading}
                subHeading={hireMobileAIMLEngeniersContent?.faqSection.subHeading}
            />

            <SoftwareCompanyCta content={hireMobileAIMLEngeniersContent?.comapnyCtaContent} />

            <Footer />
        </>
    )
}

export default HireMobileAIMLEngeniers